
import axiosInstance from '../axiosInstance';

export const registerCandidate = (candidateData) => {
  return axiosInstance.post('/user/register/candidate', candidateData);
};
  
export const fetchTotalCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/total-candidates?page=${page}&size=${size}`);
};

export const fetchLoginExpiredCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/loginExpired/candidates?page=${page}&size=${size}`);
};

export const fetchBgvInProgressCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/inProgress/candidates?page=${page}&size=${size}`);
};

export const fetchSubmittedCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/submit/candidates?page=${page}&size=${size}`);
};

export const fetchBgvCompletedCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/bgvCompleted/candidates?page=${page}&size=${size}`);
};

export const fetchUserCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/pending/candidates?page=${page}&size=${size}`);
};

export const fetchUserDashboardData = () => {
  //console.log("resp:"+JSON.stringify(axiosInstance.get('/user/home')));
  return axiosInstance.get('/user/home');
};

export const fetchUserProfile = () => {
  return axiosInstance.get('/user/user/profile');
};

export const updatePhoneNumber = (mobileNo, email) => {
  return axiosInstance.put(`/user/updatePhoneNumber/${mobileNo}/${email}`);
};

export const fetchpendingsubmissionCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/nonSubmit/candidates?page=${page}&size=${size}`);
};
export const startCandidateBGC = (candidateId) => {
  return axiosInstance.post(`/user/start-bgc`, null, {
    params: { candidateId },
  });
};
export const fetchRecentCandidates = (page = 0, size = 10) => {
  return axiosInstance.get(`/user/recent?page=${page}&size=${size}`);
};
export const fetchCandidateInfo = (candidateId, page = 0, size = 10) => {
  return axiosInstance.get(`/user/candidateInfo/${candidateId}`);
};

export const restoreCandidate = (candidateId) => {
  return axiosInstance.post(`/user/refresh-candidate/${candidateId}`);
};

export const softDeleteCandidate = (candidateId) => {
  return axiosInstance.put(`/user/soft-delete/${candidateId}`);
};



export const fetchFullCandidateReport = (candidateId) => {
  return axiosInstance.get(`/user/candidate-verification/${candidateId}`);
};

export const downloadReport = async (candidateId) => {
  //console.log("canddd:"+candidateId);
  const response = await axiosInstance.get(`/user/generate/${candidateId}`, {
    responseType: 'blob',
  });
  return response.data;
};
 
export const confirmUserAccount = (token) => {
  //console.log("stoken:"+token);
  return axiosInstance.get(`/user/confirm-account?token=${token}`);
};

export const fetchNotifications = () => {
  return axiosInstance.get('/user/notifications');
};


